// @flow

import type {TreeStructure, ExpandedTree} from '../typedef';

export const expandMatchedTree = (filteredTree: TreeStructure): ExpandedTree =>
    filteredTree.reduce((acc, item) => {
        let children = {};
        const currentChildren = item.children;
        let isCurrentExpanded = false;
        if (currentChildren) {
            children = expandMatchedTree(currentChildren);
            isCurrentExpanded = currentChildren.filter(i => i.captionMatchedSearch).length > 0 ||
                Object.keys(children).filter(id => children[id].expanded).length > 0;
        }
        acc[item.id] = {
            expanded: isCurrentExpanded,
            ...(Object.keys(children).length ? {children} : {})
        };
        return acc;
    }, {});
